import React from "react";
import {
  DashboardApplication
} from "../../_metronic/_partials";

export function ApplicationReportPage() {
  return <DashboardApplication />;
}
